import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "account-info"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "benefits-lost-section"
}
const _hoisted_5 = { class: "benefits-lost" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }

import { AccountStatus } from '@/models/interfaces'


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountStatusInfo',
  props: {
    accountStatus: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.accountStatus.subscription_status === 'active')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " You currently have an active subscription. Please cancel your subscription in Billing first before proceeding with account deletion. "))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (__props.accountStatus.subscription_status === 'canceled')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Your subscription has been canceled, but it still has time remaining before access ends. Consider deleting your account after your subscription ends to get the most out of your subscription. "))
            : _createCommentVNode("", true),
          _cache[1] || (_cache[1] = _createElementVNode("div", null, " When you delete your account, you'll lose everything in your account, including your reading history, highlights, and messages. This action is permanent and cannot be undone. ", -1)),
          (
          __props.accountStatus.user_doc_count > 0 ||
          __props.accountStatus.highlight_count > 0 ||
          __props.accountStatus.workout_count > 0
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _cache[0] || (_cache[0] = _createElementVNode("div", null, "By deleting your account, you'll permanently lose:", -1)),
                _createElementVNode("div", _hoisted_5, [
                  (__props.accountStatus.user_doc_count > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Books in your library: " + _toDisplayString(__props.accountStatus.user_doc_count), 1))
                    : _createCommentVNode("", true),
                  (__props.accountStatus.highlight_count > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Saved highlights: " + _toDisplayString(__props.accountStatus.highlight_count), 1))
                    : _createCommentVNode("", true),
                  (__props.accountStatus.workout_count > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Completed exercises: " + _toDisplayString(__props.accountStatus.workout_count), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})